const a={Monday:1,Tuesday:2,Wednesday:3,Thursday:4,Friday:5,Saturday:6,Sunday:0},d=d=>(new Date).getDay()-a[d]==-1?"tomorrow":d;export{d as getCorrectDayTwoDayDelivery};
//# sourceMappingURL=getCorrectDayTwoDayDelivery.js.map
